import React from 'react';

import styled from 'styled-components';

import useFooterLines from '@hooks/Layout/UseFooterLines';

const StyledPrintableFooter = styled.div`
    /* media query for print */
    @media print {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem;
    text-align: center;
    p {
        margin: 0;
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
    }
`;

const PrintableFooter = () => {
    const footerLines = useFooterLines();
    return (
        <StyledPrintableFooter>
            {footerLines.map((line, index) => (
                <p key={index}>{line}</p>
            ))}
        </StyledPrintableFooter>
    );
};

export default PrintableFooter;
